import { Spin, Table } from 'antd';
import { useMemo } from 'react';

import type { ModelProductOperation } from '@app/api/Products';
import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/WarehouseOperations/data';
import type { OperationsTableType } from '@app/pages/Warehouses/WarehouseOperations/types';
import {
  getOperationRowKey,
  getRange,
} from '@app/pages/Warehouses/WarehouseOperations/utils';

const TABLE = `${PF}_table`;

export const OperationsTable: OperationsTableType = ({
  columns,
  data,
  pagination: { Page, ItemsPerPage, Total },
  onPaginate,
  isPageLoading = false,
  isFetching = false,
}) => {
  const { isMobile } = useWindowSize();
  const { from, to } = useMemo(
    () => getRange({ ItemsPerPage, Total, Page }),
    [ItemsPerPage, Total, Page]
  );

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <Table<ModelProductOperation>
          columns={columns}
          dataSource={data}
          rowKey={getOperationRowKey}
          pagination={
            Total > 0
              ? {
                  responsive: true,
                  current: Page,
                  total: Total,
                  pageSize: ItemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: onPaginate,
                  disabled: isFetching,
                  showTotal: (total) =>
                    isMobile
                      ? `Всего ${total}`
                      : `Показаны результаты с ${from} по ${to} из ${total}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          loading={isFetching}
          className={`${TABLE}_grid`}
          scroll={{ x: 'max-content' }}
        />
      </div>
    </div>
  );
};
